import { required } from '@validations'
import VueRecaptcha from 'vue-recaptcha'
import axiosIns from '@/libs/axios'
import { convertSecondsToMinutes, toWaitSeconds } from '@/utils'

export default {
  components: { VueRecaptcha },
  data() {
    return {
      convertSecondsToMinutes,
      required,
      currentQuestion: {},
      selectedAnswer: null,
      userAnswers: [],
      otpModal: false,
      mobileNumber: this.$route.query.mobile || '',
      otpNumber: '',
      email: this.$route.query.email || '',
      isNextQuestionAvailable: true,
      end: false,
      change: false,
      verifyCounter: 0,
      resendOtpLoading: false,
      sendOtpLoading: false,
      verifyLoading: false,
      confirmCode: '',
      recaptcha: '',
      isVerified: false,
      countdownInterval: null,
      questions: [
        {
          question: 'میزان آشنایی شما با بازار فارکس؟',
          options: [
            { value: 'no_experience', text: 'هیچ آشنایی ندارم' },
            { value: 'learning', text: 'در حال آموزش و یادگیری هستم' },
            { value: 'professional_trader', text: 'کاملا آشنا هستم و سابقه ترید دارم' },
            // { value: 'familiar_no_trade', text: 'آشنا هستم ولی تمایلی به ترید کردن ندارم' },
          ],
          condition: question => question.length === 0, /* && (question[0].answer.value === 'trade_income' || question[0].answer.value === 'partner_income'), */
        },
        {
          question: 'از چه روشی در بازار های مالی میخواهید سود کسب کنید؟',
          options: [
            { value: 'trade_income', text: 'درآمد دلاری از طریق ترید کردن.' },
            { value: 'partner_income', text: 'درآمد دلاری از طریق مشارکت با تریدر های حرفه ای.' },
            { value: 'dollar_investment', text: 'درآمد دلاری از طریق سرمایه‌گذاری.' },
            { value: 'rial_investment', text: 'درآمد ریالی از طریق سرمایه‌گذاری.' },
          ],
          condition: question => question.length === 1,
        },
        {
          question: 'میزان سرمایه‌گذاری به ریال؟',
          options: [
            { value: '1-10_million', text: '10,000,000 - 100,000,000 ریال' },
            { value: '11-50_million', text: '110,000,000 - 500,000,000 ریال' },
            { value: '50-100_million', text: '510,000,000 -1000,000,000  ریال' },
            { value: '101-500_million', text: '1,010,000,000 - 5,000,000,000 ریال' },
            { value: 'above_500_million', text: 'بالای 5,000,000,000 ریال' },
          ],
          condition: question => question.length === 2 && question[1].answer.value === 'rial_investment',
        },
        {
          question: 'میزان سرمایه‌گذاری به دلار؟',
          options: [

            { value: '1-10_dollar', text: '10 - 100 دلار' },
            { value: '11-50_dollar', text: '101 - 500 دلار' },
            { value: '50-100_dollar', text: '501 - 1000  دلار' },
            { value: '101-500_dollar', text: '1001 - 5000 دلار' },
            { value: 'above_500_dollar', text: 'بالای 5000 دلار' },
          ],
          condition: question => question.length === 2 && question[1].answer.value === 'dollar_investment',
        },
        {
          question: 'میزان توقع شما از میزان درامد در ماه؟',
          options: [

            { value: '0_5_percent', text: '0-5 درصد' },
            { value: '6_10_percent', text: '6-10 درصد' },
            { value: '11_30_percent', text: '11-30 درصد' },
            { value: '31_50_percent', text: '31-50 درصد' },
            { value: '51_80_percent', text: '51-80 درصد' },
            { value: '81_100_percent', text: '81 - 100 درصد' },
            { value: 'above_100_percent', text: '100 درصد به بالا' },
          ],
          condition: question => question.length === 2 && (question[1].answer.value === 'no_experience' || question[1].answer.value === 'learning'),
        },
        {
          question: 'سابقه فعالیت در بازار فارکس؟',
          options: [

            { value: '0_2_years', text: '0-2 سال' },
            { value: '2_5_years', text: '2-5 سال' },
            { value: 'above_5_years', text: '5 سال به بالا' },
          ],
          condition: question => question.length === 2 && (question[1].answer.value === 'trade_income' || question[1].answer.value === 'partner_income')
           && question[0].answer.value === 'professional_trader',
        },
        {
          question: 'آیا در بروکر دیگری فعالیت میکنید؟',
          options: [
            { value: 'no', text: 'خیر' },
            { value: 'yes', text: 'بله' },
          ],
          condition: question => question.length === 3 && question[0].answer.value === 'professional_trader',
        },
        {
          answerType: 'text',
          optional: true,
          question: 'لطفا نام بروکر را وارد کنید.',
          options: [
            { value: 'no', text: 'خیر' },
            { value: 'yes', text: 'بssله' },
          ],
          condition: question => question.length === 4 && question[0].answer.value === 'professional_trader' && question[3].answer.value === 'yes',
        },
      ],
      offers:
        {
          no_experience: {
            text: 'بروکر PCM با سابقه ی 12 سال حضور در بازارهای مالی خدمات متنوعی را در اختیار مشتریان عزیز قرار میدهد.',
            description: 'متخصصین و مربیان ما آماده هستند تا در این مسیر شما را یاری کنند. لطفا شماره موبایل خود را ثبت کنید تا با شما تماس بگیریم.',
            subText: 'همچنین می‌توانید بخشی از خدمات ما را از لینک های زیر بررسی کنید',
            links: [
              {
                title: 'دانشگاه تریدری',
                description: 'دانشگاه تریدری محیطی مناسب برای یادگیری بازارهای مالی و فارکس است که با دوره های متنوع و مناسب با هدف شما آماده شده است.',
                link: 'https://pcmfa.academy/',
              },
              {
                title: 'امکان همکاری با تریدرهای حرفه‌ای و کسب درآمد دلاری.',
                description: 'مجموعه PCM این امکان را برای مشتریان عزیز فراهم کرده که با استفاده کابین مشتریان بتوانند با تریدر های موفق همکاری کرده و بعد از توافق با آنها درآمد دلاری کسب کنند. برای اطلاعات بیشتر منتظر تماس متخصصین ما باشید.',
                link: 'https://pcmgate.co',
              },
              {
                title: 'کابین مشتریان',
                description: 'این کابین محیط مناسبی برای فعالیت مشتریان در بازار های مالی است که با امکانات و ابزارهای لازم برای فعالیت در بازار فارکس، آماده شده است.',
                link: 'https://pcmgate.co',
              },
            ],
          },
          learning: {
            text: 'بروکر PCM با سابقه ی 12 سال حضور در بازارهای مالی خدمات متنوعی را در اختیار مشتریان عزیز قرار میدهد. دانشگاه تریدری یکی از خدمات مجموعه است که به شما کمک می کند تا تریدر موفق تری در بازارهای مالی باشید.',
            description: 'متخصصین و مربیان ما آماده هستند تا به شما در یادگیری و پیشرفت در بازارهای مالی کمک کنند. لطفا شماره موبایل خود را وارد کنید تا با شما تماس بگیریم.',
            subText: '',
            links: [
              {
                title: 'دانشگاه تریدری',
                description: 'دانشگاه تریدری محیطی مناسب برای یادگیری بازارهای مالی و فارکس است که با دوره های متنوع و مناسب با هدف شما آماده شده است.',
                link: 'https://pcmfa.academy/',
              },
              {
                title: 'امکان همکاری با تریدر های حرفه ای و کسب درآمد دلاری.',
                description: 'مجموعه PCM این امکان را برای مشتریان عزیز فراهم کرده که با استفاده کابین مشتریان بتوانند با تریدر های موفق همکاری کرده و بعد از توافق با آنها درآمد دلاری کسب کنند. برای اطلاعات بیشتر منتظر تماس متخصصین ما باشید.',
                link: 'https://pcmgate.co',
              },
              {
                title: 'کابین مشتریان',
                description: 'این کابین محیط مناسبی برای فعالیت مشتریان در بازار های مالی است که با امکانات و ابزارهای لازم برای فعالیت در بازار فارکس، آماده شده است.',
                link: 'https://pcmgate.co',
              },
            ],
          },
          professional_trader: {
            text: 'بروکر PCM با سابقه ی 12 سال حضور در بازارهای مالی خدمات متنوعی را در اختیار تریدر های حرفه ای قرار میدهد. کابین مشتریان با خدمات متنوع مکان مناسبی برای تریدر های حرفه ای می باشد.',
            description: 'مجموعه ما آفر ویژه ای برای تریدر های حرفه ای در نظر دارد که توسط متخصصین ما به شما معرفی خواهد شد. لطفا شماره موبایل خود را ثبت کنید تا با شما تماس بگیریم.',
            subText: 'همچنین می‌توانیدید بخشی از خدمات ما را از لینک های زیر بررسی کنید',
            links: [
              {
                title: 'کابین مشتریان',
                description: 'این کابین محیط مناسبی برای فعالیت مشتریان در بازار های مالی است که با امکانات و ابزارهای لازم برای فعالیت در بازار فارکس، آماده شده است.',
                link: 'https://pcmgate.co',
              },
              {
                title: 'امکان جذب سرمایه برای تریدر های حرفه ای',
                description: 'مجموعه ما امکان همکاری مشتریان با تریدر های حرفه ای را فراهم نموده که امکان درامد بیشتر را برای تریدر های محترم فراهم می کند. برای اطلاعات بیشتر منتظر تماس متخصصین ما باشید.',
                link: 'https://pcmgate.co',
              },
              {
                title: 'لیست حساب‌های فارکس',
                description: 'ما در مجموعه PCM حساب های متنوعی را ارائه می‌کنیم که متناسب با نیاز های مختلف شما می باشد.',
                link: 'https://pcmfa.co/types-of-accounts',
              },
            ],
          },
          familiar_no_trade: {
            text: 'در صورتی که تمایل ندارید خودتان به صورت مستقیم ترید کنید مجموعه PCM امکانی را در اختیار شما قرار می دهد که با همکاری تریدرها حرفه ای و توافق با آن‌ها بتوانید از سرمایه خود بهترین استفاده را نمایید.',
            description: 'برای اطلاعات بیشتر لطفا شماره موبایل خود را ثبت کنید تا متخصصین ما با شما تماس بگیرند.',
            subText: 'همچنین می‌توانیدید بخشی از خدمات ما را از لینک های زیر بررسی کنید',
            links: [
              {
                title: 'امکان همکاری با تریدر های حرفه ای و کسب درآمد دلاری.',
                description: 'مجموعه PCM این امکان را برای مشتریان عزیز فراهم کرده که با استفاده کابین مشتریان بتوانند با تریدر های موفق همکاری کرده و بعد از توافق با آنها درآمد دلاری کسب کنند. برای اطلاعات بیشتر منتظر تماس متخصصین ما باشید.',
                link: 'https://pcmgate.co',
              },
              {
                title: 'کابین مشتریان',
                description: 'این کابین محیط مناسبی برای فعالیت مشتریان در بازار های مالی است که با امکانات و ابزارهای لازم برای فعالیت در بازار فارکس، آماده شده است.',
                link: 'https://pcmgate.co',
              },
            ],
          },
          rial_investment: {
            text: 'مجموعه PCM امکانی را برای مشتریان محترم فراهم نموده که با سرمایه‌گذاری در بازار های مالی می‌توانیدید از سرمایه خود بهترین استفاده را نمایید. به طور میانگین میزان سود سرمایه‌گذاری در PCM حدود 35 درصد است.',
            description: 'برای اطلاعات بیشتر لطفا شماره موبایل خود را ثبت کنید تا متخصصین ما با شما تماس بگیرند.',
            subText: 'همچنین می‌توانیدید بخشی از خدمات ما را از لینک های زیر بررسی کنید.',
            links: [
              {
                title: 'کابین مشتریان',
                description: 'این کابین محیط مناسبی برای فعالیت مشتریان در بازار های مالی است که با امکانات و ابزارهای لازم برای فعالیت در بازار فارکس، آماده شده است.',
                link: 'https://pcmgate.co',
              },
              {
                title: 'امکان جذب سرمایه برای تریدر های حرفه ای',
                description: 'مجموعه ما امکان همکاری مشتریان با تریدر های حرفه ای را فراهم نموده که امکان درامد بیشتر را برای تریدر های محترم فراهم می کند. برای اطلاعات بیشتر منتظر تماس متخصصین ما باشید.',
                link: 'https://pcmgate.co',
              },
            ],
          },
          dollar_investment: {
            text: 'مجموعه PCM امکانی را برای مشتریان محترم فراهم نموده که با سرمایه‌گذاری در بازار های مالی می‌توانیدید از سرمایه خود بهترین استفاده را نمایید.',
            description: 'برای اطلاعات بیشتر لطفا شماره موبایل خود را ثبت کنید تا متخصصین ما با شما تماس بگیرند.',
            subText: 'همچنین می‌توانیدید بخشی از خدمات ما را از لینک های زیر بررسی کنید.',
            links: [
              {
                title: 'کابین مشتریان',
                description: 'این کابین محیط مناسبی برای فعالیت مشتریان در بازار های مالی است که با امکانات و ابزارهای لازم برای فعالیت در بازار فارکس، آماده شده است.',
                link: 'https://pcmgate.co',
              },
              {
                title: 'امکان جذب سرمایه برای تریدر های حرفه ای',
                description: 'مجموعه ما امکان همکاری مشتریان با تریدر های حرفه ای را فراهم نموده که امکان درامد بیشتر را برای تریدر های محترم فراهم می کند. برای اطلاعات بیشتر منتظر تماس متخصصین ما باشید.',
                link: 'https://pcmgate.co',
              },
            ],
          },
        },
    }
  },
  computed: {
    sitekey() {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY
    },
  },
  watch: {
    userAnswers: {
      handler() {
        this.selectedAnswer = null
        this.isNextQuestionAvailable = false
        this.questions.forEach(question => {
          if (question.condition && question.condition(this.userAnswers/* [this.userAnswers.length === 0 ? 0 : this.userAnswers.length - 1] */)) {
            this.currentQuestion = question
            this.isNextQuestionAvailable = true
          }
        })
        if (!this.isNextQuestionAvailable) {
          this.end = true
        }
      },
      deep: true,
    },
  },
  mounted() {
    const [q] = this.questions
    this.currentQuestion = q
  },
  methods: {
    getOffer() {
      return this.offers[this.userAnswers[this.userAnswers[0].answer.value === 'trade_income' || this.userAnswers[0].answer.value === 'partner_income' ? 1 : 0].answer.value]
    },
    handleNextStep() {
      this.change = true
      setTimeout(() => {
        this.change = false
        if (this.selectedAnswer || this.currentQuestion.optional) {
          this.userAnswers.push({
            question: this.currentQuestion.question,
            answer: this.currentQuestion.answerType === 'text'
              ? { value: this.selectedAnswer, text: this.selectedAnswer }
              : this.currentQuestion.options.find(option => option.value === this.selectedAnswer),
          })
        }
      }, 500)
    },
    countDownTimer() {
      if (!this.countdownInterval) {
        this.countdownInterval = setInterval(() => {
          if (this.verifyCounter > 0) {
            this.verifyCounter -= 1
          }
        }, 1000)
      }
    },
    sendOtpCode(resend = false) {
      if (resend) {
        this.resendOtpLoading = true
      } else {
        this.sendOtpLoading = true
      }
      axiosIns.post('campaign/send-otp', { uuid: this.$route.query.uuid, mobile: this.mobileNumber.replace(/^0/, ''), mobile_country_code: '98' }).then(res => {
        this.otpModal = true
        this.verifyCounter = toWaitSeconds(res.data.results.expiration_time * 60)
        this.countDownTimer()
        this.$swal({
          title: 'کد تایید ارسال شد.',
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
      }).catch(error => {
        if (error.status === 428) {
          this.otpModal = true
          this.verifyCounter = toWaitSeconds(error.data.results.time)
          this.countDownTimer()
        }
      }).finally(() => {
        this.sendOtpLoading = false
        this.resendOtpLoading = false
      })
    },
    verify() {
      this.verifyLoading = true
      axiosIns.post('quick-register', {
        uuid: this.$route.query.uuid,
        mobile: this.mobileNumber.replace(/^0/, ''),
        questions: JSON.stringify(this.userAnswers),
        email: this.email,
        code: this.confirmCode,
        recaptcha: this.recaptcha,
      }).then(() => {
        this.$swal({
          title: 'شماره شما ثبت شد، یک لینک تایید و رمز عبور کابین مشتریان برای شما ارسال شد. لطفا منتظر تماس متخصصین ما باشید.',
          icon: 'success',
          timer: 6000,
          showConfirmButton: false,
        })
        this.otpModal = false
        this.isVerified = true
      }).finally(() => {
        this.verifyLoading = false
      })
    },
    onVerify(response) {
      this.recaptcha = response
    },
    async onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.recaptcha = null
    },
    openLink(link) {
      if (this.isVerified) {
        window.open(link, '_blank')
      } else {
        this.$swal({
          title: 'لطفا ابتدا شماره موبایل خود را از انتهای صفحه تایید کنید.',
          icon: 'error',
          showConfirmButton: false,

        })
      }
    },
  },
}
